import API from '../../../api/API';

export default class DiscountRateAPI extends API {
  constructor(parameters = {}) {
    super('/DiscountRate', parameters);
  }

  loadAllDiscountRates() {
    return this.submit("get", `${this.endpoint}`);
  }

  setDiscountRate(discountRate) {
    return this.submit("post", `${this.endpoint}`, discountRate);
  }
  validateDiscountRate(discountRate) {
    return this.submit("post", `${this.endpoint}/ValidateDiscountRate`, discountRate);
  }
  editDiscountRate(discountRate) {
    return this.submit("put", `${this.endpoint}/${discountRate.idInDb}`, discountRate);
  }
  contractsForRecalculationDownloadExcel(item) {
    return this.export("post", `${this.endpoint}/ContractsForRecalculationDownloadExcel`, item);
  }

  contractsWithoutDiscountRate(item) {
    return this.export("post", `${this.endpoint}/ContractsWithoutDiscountRate`, item);
  }

  saveExcelImportWithNewDiscountRates(item) {
    return this.submit('post', `${this.endpoint}/SaveExcelImportWithNewDiscountRates`, item);
  }

  async downloadAllDiscountRates() {
    return await this.export("post", `${this.endpoint}/downloadAllDiscountRates`);
  }
}
